export default function () {
  $('#account_client').change(function() {
    toggleInvoiceIndex($(this));
  });

  var toggleInvoiceIndex = function(checkbox) {
    var invoiceIndex = $('#account_invoiceIndex');
    var quickBooksId = $('#account_quickBooksId');

    if (!checkbox.is(':checked')) {
      disable(invoiceIndex);
      disable(quickBooksId);
    } else {
      enable(invoiceIndex);
      enable(quickBooksId);
    }
  };

  toggleInvoiceIndex($('#account_client'));
};

function disable(input) {
  input.attr('disabled', true);
  input.data('oldVal', input.val());
  input.val('');
}

function enable(input) {
  input.attr('disabled', false);
  var oldVal = input.data('oldVal');
  if (oldVal) {
    input.val(oldVal);
  }
}

function updateQuickBooksHelp() {
  var accountName = $('#account_name').val();
  var query = `select * from Customer where CompanyName like '${accountName}%'`

  $('#account_quickBooksId_help').html(`<a href="/quickbooks/query?q=${query}">Find in QuickBooks</a>`);
}

$('#account_name').keyup(updateQuickBooksHelp);
updateQuickBooksHelp();



// WEBPACK FOOTER //
// ./assets/js/account-edit.js